import $axios from "../../api";
import FileSaver from "file-saver";
import moment from 'moment'

const state = () => ({
  isLoading: false,
  isSuccess: false,
  errors: null,
  dashboardData: {},

  isLoadingDetail: false,
  isSuccessDetail: false,

  statisticsLoading: false,
  statisticsSuccess: false,
  statisticsErrors: null,
  statistics: {},

  storesProductsLoading: false,
  storesProductsSuccess: false,
  storesProductsErrors: null,
  storesProducts: {},

  categoriesBrandsLoading: false,
  categoriesBrandsSuccess: false,
  categoriesBrandsErrors: null,
  categoriesBrands: {},

  buyersLoading: false,
  buyersSuccess: false,
  buyersErrors: null,
  buyers: {},

  promotionsPaymentsLoading: false,
  promotionsPaymentsSuccess: false,
  promotionsPaymentsErrors: null,
  promotionsPayments: {},

  // level 2
  storeData: {},
  productData: {},
  categoryData: {},
  brandData: {},
  customersPerformanceData: {},
  inactiveCustomersData: {},
  voucherPromoData: {},
  paymentMethodData: {},

  // level 3
  storeDetail: {},
  productDetail: {},
  categoryDetail: {},
  brandDetail: {},
  promotionDetail: {},
  paymentDetail: {},
  paymentType: [],
  memberList: [],
  paymentNameList: [],

  searchLoading: false,
  page: 1,
  pageDetail: 1,
})

const getters = {
  transformStatistics: (state) => {
    const data = state.statistics
    if (!data || !data.statistics_sales) return null
    moment.locale('id')
    if (data.statistics_sales.statisticItems && data.statistics_sales.statisticItems[0]) {
      data.statistics_sales.statisticItems[0].currency = true
    }
    if (data.last_update) {
      data.last_update = `Terakhir di perbarui ${moment(new Date(data.last_update)).format("DD MMM YYYY")}`
    }
    return data
  },
  transformBuyers: (state) => {
    const data = state.buyers
    if (!data || !data.top_buyers || !data.inactive_buyers) return null
    moment.locale('id')

    data.inactive_buyers = data.inactive_buyers.map(buyer => ({
      member_name: buyer.member_name,
      isVip: buyer.is_vip,
      tier: buyer.tier,
      card_code: buyer.card_code,
      orders: buyer.total_order,
      total: buyer.total_transaction,
      lastPurchase: moment(buyer.last_purchase).format("DD MMM YYYY H:mm")
    }))

    data.top_buyers = data.top_buyers.map(buyer => ({
      member_name: buyer.member_name,
      isVip: buyer.is_vip,
      tier: buyer.tier,
      card_code: buyer.card_code,
      orders: buyer.total_order,
      total: buyer.total_transaction,
    }))
    return data
  },

  convertObjectToArray: (state) => (data) => {
    if (Array.isArray(data)) return data

    if (typeof data === 'object') return Object.values(data)

    return []
  }
}

const mutations = {
  // === LOADING STATUS MUTATIONS ===
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_DETAIL(state, payload) {
    state.isLoadingDetail = payload;
  },
  SET_STATISTICS_LOADING(state, payload) {
    state.statisticsLoading = payload;
  },
  SET_STORES_PRODUCTS_LOADING(state, payload) {
    state.storesProductsLoading = payload;
  },
  SET_CATEGORIES_BRANDS_LOADING(state, payload) {
    state.categoriesBrandsLoading = payload;
  },
  SET_BUYERS_LOADING(state, payload) {
    state.buyersLoading = payload;
  },
  SET_PROMOTIONS_PAYMENTS_LOADING(state, payload) {
    state.promotionsPaymentsLoading = payload;
  },
  SET_SEARCH_LOADING(state, payload) {
    state.searchLoading = payload;
  },

  // === SUCCESS STATUS MUTATIONS ===
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_SUCCESS_DETAIL(state, payload) {
    state.isSuccessDetail = payload;
  },
  SET_STATISTICS_SUCCESS(state, payload) {
    state.statisticsSuccess = payload;
  },
  SET_STORES_PRODUCTS_SUCCESS(state, payload) {
    state.storesProductsSuccess = payload;
  },
  SET_CATEGORIES_BRANDS_SUCCESS(state, payload) {
    state.categoriesBrandsSuccess = payload;
  },
  SET_BUYERS_SUCCESS(state, payload) {
    state.buyersSuccess = payload;
  },
  SET_PROMOTIONS_PAYMENTS_SUCCESS(state, payload) {
    state.promotionsPaymentsSuccess = payload;
  },

  // === ERROR STATUS MUTATIONS ===
  ASSIGN_ERRORS(state, payload) {
    state.errors = payload;
  },
  ASSIGN_STATISTICS_ERRORS(state, payload) {
    state.statisticsErrors = payload;
  },
  ASSIGN_STORES_PRODUCTS_ERRORS(state, payload) {
    state.storesProductsErrors = payload;
  },
  ASSIGN_CATEGORIES_BRANDS_ERRORS(state, payload) {
    state.categoriesBrandErrors = payload;
  },
  ASSIGN_BUYERS_ERRORS(state, payload) {
    state.buyersErrors = payload;
  },
  ASSIGN_PROMOTIONS_PAYMENTS_ERRORS(state, payload) {
    state.promotionPaymentErrors = payload;
  },

  // === DATA ASSIGNMENT MUTATIONS ===
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_PAGE_DETAIL(state, payload) {
    state.pageDetail = payload;
  },

  // Level 1 data assignments (mapping to specific objects)
  ASSIGN_STATISTICS_DATA(state, payload) {
    state.statistics = payload;
  },
  ASSIGN_STORES_PRODUCTS_DATA(state, payload) {
    state.storesProducts = payload;
  },
  ASSIGN_CATEGORIES_BRANDS_DATA(state, payload) {
    state.categoriesBrands = payload;
  },
  ASSIGN_BUYERS_DATA(state, payload) {
    state.buyers = payload;
  },
  ASSIGN_PROMOTIONS_PAYMENTS_DATA(state, payload) {
    state.promotionsPayments = payload;
  },
  ASSIGN_DASHBOARD_DATA(state, payload) {
    state.dashboardData = payload;
  },

  // Level 2 data assignments (already exist)
  ASSIGN_STORE_DATA(state, payload) {
    state.storeData = payload;
  },
  ASSIGN_PRODUCT_DATA(state, payload) {
    state.productData = payload;
  },
  ASSIGN_CATEGORY_DATA(state, payload) {
    state.categoryData = payload;
  },
  ASSIGN_BRAND_DATA(state, payload) {
    state.brandData = payload;
  },
  ASSIGN_CUSTOMERS_PERFORMANCE_DATA(state, payload) {
    state.customersPerformanceData = payload;
  },
  ASSIGN_INACTIVE_CUSTOMERS_DATA(state, payload) {
    state.inactiveCustomersData = payload;
  },
  ASSIGN_VOUCHER_PROMO_DATA(state, payload) {
    state.voucherPromoData = payload;
  },
  ASSIGN_PAYMENT_METHOD_DATA(state, payload) {
    state.paymentMethodData = payload;
  },

  // Level 3 data assignments (already exist)
  ASSIGN_STORE_DETAIL_DATA(state, payload) {
    state.storeDetail = payload;
  },
  ASSIGN_PRODUCT_DETAIL_DATA(state, payload) {
    state.productDetail = payload;
  },
  ASSIGN_CATEGORY_DETAIL_DATA(state, payload) {
    state.categoryDetail = payload;
  },
  ASSIGN_BRAND_DETAIL_DATA(state, payload) {
    state.brandDetail = payload;
  },
  ASSIGN_PROMOTION_DETAIL_DATA(state, payload) {
    state.promotionDetail = payload;
  },
  ASSIGN_PAYMENT_DETAIL_DATA(state, payload) {
    state.paymentDetail = payload;
  },

  // List data assignments (already exist)
  ASSIGN_PAYMENT_TYPE_DATA(state, payload) {
    state.paymentType = payload;
  },
  ASSIGN_MEMBER_LIST_DATA(state, payload) {
    state.memberList = payload;
  },
  ASSIGN_PAYMENT_NAME_LIST_DATA(state, payload) {
    state.paymentNameList = payload;
  },
}

const actions = {
  async getDashboardData({ commit, state, rootState, dispatch }, { section, payload }) {

    const validSections = [
      'statistics',
      'stores_products',
      'categories_brands',
      'buyers',
      'promotions_payments'
    ];

    if (!validSections.includes(section)) {
      console.error(`Invalid section provided: ${section}`);
      dispatch("Main/globalSweetAlert", {
        status: 400,
        data: { message: `Bagian dashboard tidak valid: ${section}` }
      }, { root: true });
      return;
    }

    const loadingMutation = `SET_${section.toUpperCase()}_LOADING`;
    const successMutation = `SET_${section.toUpperCase()}_SUCCESS`;
    const errorMutation = `ASSIGN_${section.toUpperCase()}_ERRORS`;
    const dataAssignmentMutation = `ASSIGN_${section.toUpperCase()}_DATA`;

    commit(loadingMutation, true);
    commit(successMutation, false);
    commit(errorMutation, null);

    try {
      const { data } = await $axios.get(`store/dash/1/${section}`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store: payload?.store,
        }
      });
      commit(successMutation, true);
      commit(dataAssignmentMutation, data.data);
    } catch (error) {
      commit(errorMutation, error.response || error);
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(loadingMutation, false);
    }
  },
  async getStoreData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/store`, {
        params: {
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          page: state.page,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        },
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_STORE_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getProductData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/product`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          product_name: payload?.product_name,
          brand_id: payload?.brand_id,
          category_id: payload?.category_id,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        },
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_PRODUCT_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getCategoriesData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/category`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          category_name: payload?.category_name,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_CATEGORY_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getBrandsData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/brand`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          store_code: payload?.store_code,
          brand_name: payload?.brand_name,
        },
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_BRAND_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getCustomersPerformanceData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/member`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          store_code: payload?.store_code,
          member_name: payload?.member_name,
        }
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_CUSTOMERS_PERFORMANCE_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getInactiveCustomersData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/inactive-member`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          store_code: payload?.store_code,
          member_name: payload?.member_name,
          email: payload?.email,
        }
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_INACTIVE_CUSTOMERS_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getVoucherPromoData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/promotion`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          store_code: payload?.store_code,
          promo_code: payload?.promo_code,
        },
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_VOUCHER_PROMO_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getPaymentMethodData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", true);

    try {
      const { data } = await $axios.get(`store/dash/2/payment`, {
        params: {
          page: state.page,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
          store_code: payload?.store_code,
          payment_name: payload?.payment_name,
          payment_type: payload?.payment_type,
        }
      })

      commit("SET_SUCCESS", true);
      commit("ASSIGN_PAYMENT_METHOD_DATA", data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING", false);
    }
  },
  async getStoreDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const response = await Promise.all([
        $axios.get(`store/dash/3/store/overview`, {
          params: {
            // start_date: payload?.start_date,
            // end_date: payload?.end_date,
            store_code: payload?.store_code,
          }
        }),
        $axios.get(`store/dash/3/store/transaction`, {
          params: {
            page: state.pageDetail,
            start_date: payload?.start_date,
            end_date: payload?.end_date,
            store_code: payload?.store_code,
            order_number: payload?.order_number,
            member_name: payload?.member_name,
            payment_name: payload?.payment_name,
            sortby: payload?.sortby,
            sortdesc: payload?.sortdesc,
          }
        })
      ])

      response[1]?.data?.data.data.forEach(element => {
        element.show_more_product = false
      });

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_STORE_DETAIL_DATA", {
        summary: response[0]?.data?.data.summary,
        overview: response[0]?.data?.data.overview,
        data: response[1]?.data?.data
      });
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getProductDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const { data } = await $axios.get(`store/dash/3/product`, {
        params: {
          page: state.pageDetail,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          sku: payload?.sku,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_PRODUCT_DETAIL_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getCategoryDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const { data } = await $axios.get(`store/dash/3/category`, {

        params: {
          page: state.pageDetail,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          category_id: payload?.category_id,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_CATEGORY_DETAIL_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getBrandDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const { data } = await $axios.get(`store/dash/3/brand`, {

        params: {
          page: state.pageDetail,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          brand_id: payload?.brand_id,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_BRAND_DETAIL_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getPromotionDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const { data } = await $axios.get(`store/dash/3/promotion`, {

        params: {
          page: state.pageDetail,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          promo_code: payload?.promo_code,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,

        }
      })

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_PROMOTION_DETAIL_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getPaymentDetailData({ commit, state, rootState, dispatch }, payload) {
    commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", true);

    try {
      const { data } = await $axios.get(`store/dash/3/payment`, {

        params: {
          page: state.pageDetail,
          start_date: payload?.start_date,
          end_date: payload?.end_date,
          store_code: payload?.store_code,
          payment_id: payload?.payment_id,
          sortby: payload?.sortby,
          sortdesc: payload?.sortdesc,
        }
      })

      commit("SET_SUCCESS_DETAIL", true);
      commit("ASSIGN_PAYMENT_DETAIL_DATA", data.data)
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit(payload.searchLoading ? "SET_SEARCH_LOADING" : "SET_LOADING_DETAIL", false);
    }
  },
  async getPaymentType({ commit, state, rootState, dispatch }, payload) {
    try {
      const { data } = await $axios.get(`store/payment-type`)

      commit("ASSIGN_PAYMENT_TYPE_DATA", data.data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    }
  },
  async getPaymentNameList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_SEARCH_LOADING", true);
    try {
      const { data } = await $axios.get(`store/payment-name-list`)

      commit("ASSIGN_PAYMENT_NAME_LIST_DATA", data.data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_SEARCH_LOADING", false);
    }
  },
  async getMemberList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_SEARCH_LOADING", true);
    try {
      const { data } = await $axios.get(`store/member-list`, {

        params: {
          search: payload ?? ''
        }
      })

      commit("ASSIGN_MEMBER_LIST_DATA", data.data);
    } catch (error) {
      dispatch("Main/globalSweetAlert", error.response, { root: true });
    } finally {
      commit("SET_SEARCH_LOADING", false);
    }
  },
  exportStore({ commit, state, rootState, dispatch }, payload) {
    const queryString = payload
      ? payload.startsWith("&")
        ? `?${payload.slice(1)}`
        : payload
      : "";
    return new Promise((resolve, reject) => {
      $axios
        .get(`store/dash/export/store${queryString}`, {
          responseType: "blob",
        })
        .then((res) => {
          const fileName = `performanceStore_view=${rootState.Main.view}${queryString || ""}_${new Date().toISOString().slice(0, 19).replace(/[:-]/g, "")}.xlsx`;
          FileSaver.saveAs(res.data, fileName);
          resolve(res);
        })
        .catch((error) => {
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};